import { useEffect } from "react"
import { usePostHog } from "./posthog.provider"

interface PostHogIdentifyParams {
  userId: string | null | undefined
  email: string | null | undefined
}

export const usePostHogIdentify = ({
  userId,
  email,
}: PostHogIdentifyParams) => {
  const posthog = usePostHog()

  useEffect(() => {
    if (!posthog) return

    if (userId) {
      posthog.identify(userId, { email: email ?? undefined })
    } else {
      posthog.reset()
    }
  }, [posthog, userId, email])
}
